<template>
  <v-container class="mt-8">
    <v-card variant="flat" class="pa-2">
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <!-- Grupo: Dados da Empresa -->
          <v-card class="mb-4" flat outlined>
            <v-card-title class="subtitle-1 font-weight-bold"
              >Dados da Empresa</v-card-title
            >
            <v-card-text>
              <v-row dense>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    prepend-inner-icon="mdi-card-account-details"
                    v-model="cliente.cnpj_cpf"
                    label="CNPJ/CPF"
                    :rules="[rules.required]"
                    required
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model="cliente.inscricao_estadual"
                    label="Inscrição Estadual"
                    prepend-inner-icon="mdi-file-document-outline"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="cliente.razao_social"
                    label="Razão Social"
                    :rules="[rules.required]"
                    prepend-inner-icon="mdi-domain"
                    required
                  />
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="cliente.nome_fantasia"
                    label="Nome Fantasia"
                    :rules="[rules.required]"
                    prepend-inner-icon="mdi-account"
                    required
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-divider></v-divider>
          <!-- Grupo: Contato -->
          <v-card class="mb-4" flat outlined>
            <v-card-title class="subtitle-1 font-weight-bold"
              >Contato</v-card-title
            >
            <v-card-text>
              <v-row dense>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model="cliente.email"
                    label="E-mail"
                    :rules="[rules.required]"
                    prepend-inner-icon="mdi-email"
                    required
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model="cliente.telefone"
                    label="Telefone"
                    :rules="[rules.required]"
                    prepend-inner-icon="mdi-phone"
                    required
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-divider></v-divider>
          <!-- Grupo: Endereço -->
          <v-card class="mb-4" flat outlined>
            <v-card-title class="subtitle-1 font-weight-bold"
              >Endereço</v-card-title
            >
            <v-card-text>
              <v-row dense>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model="cliente.cep"
                    label="CEP"
                    :rules="[rules.required]"
                    prepend-inner-icon="mdi-map-marker-radius"
                    required
                  />
                </v-col>
                <v-col cols="12" sm="8" md="5">
                  <v-text-field
                    v-model="cliente.endereco"
                    label="Endereço"
                    :rules="[rules.required]"
                    prepend-inner-icon="mdi-map-marker"
                    required
                  />
                </v-col>
                <v-col cols="12" sm="4" md="3">
                  <v-text-field
                    v-model="cliente.numero_endereco"
                    prepend-inner-icon="mdi-numeric"
                    label="Número"
                    :rules="[rules.required]"
                    required
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model="cliente.bairro"
                    label="Bairro"
                    :rules="[rules.required]"
                    prepend-inner-icon="mdi-home-city"
                    required
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model="cliente.complemento"
                    prepend-inner-icon="mdi-home-outline"
                    label="Complemento"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-divider></v-divider>
          <!-- Grupo: Município -->
          <v-card class="mb-2" flat outlined>
            <v-card-title class="subtitle-1 font-weight-bold">
              Município
              <v-btn
                icon
                variant="tonal"
                size="small"
                color="primary"
                class="ml-2"
                @click="dialogBuscaMunicipio = true"
                title="Buscar município"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
              <span class="ml-3 municipio-caption">
                Selecione o município pela lupa
              </span>
            </v-card-title>
            <v-card-text>
              <div v-if="cliente.codigo_municipio">
                <v-row dense>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model.number="cliente.codigo_municipio"
                      label="Código Município"
                      :rules="[rules.required]"
                      prepend-inner-icon="mdi-city"
                      readonly
                      type="number"
                    />
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="cliente.nome_municipio"
                      prepend-inner-icon="mdi-city-variant"
                      label="Nome Município"
                      :rules="[rules.required]"
                      readonly
                    />
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model.number="cliente.codigo_uf"
                      label="Código UF"
                      :rules="[rules.required]"
                      prepend-inner-icon="mdi-map"
                      readonly
                      type="number"
                    />
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="cliente.sigla_uf"
                      label="Sigla UF"
                      :rules="[rules.required]"
                      prepend-inner-icon="mdi-map-outline"
                      readonly
                    />
                  </v-col>
                </v-row>
              </div>
              <div v-else class="text-grey text-caption mt-2">
                Selecione um município clicando na lupa acima.
              </div>
            </v-card-text>
          </v-card>
        </v-form>

        <v-divider></v-divider>
        <!-- Fora do v-form: o upload e imediato, nao depende do Salvar. -->
        <LogoCliente v-if="cliente.codcliente" :codcliente="cliente.codcliente" />
      </v-card-text>
      <v-divider class="my-2"></v-divider>
      <v-card-actions>
        <v-spacer />
        <v-btn
          variant="elevated"
          color="primary"
          @click="salvarCliente"
          :loading="loading"
          block
          size="large"
        >
          <v-icon left>mdi-content-save</v-icon>
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
    <!-- Dialog de busca de município -->
    <DialogBusca
      v-model:open="dialogBuscaMunicipio"
      :rota-busca="'municipios'"
      @selecionado="selecionarMunicipio"
    />
  </v-container>
</template>

<script>
import api from "../services/api";
import { mapActions } from "vuex";
import DialogBusca from "@/components/DialogBusca.vue";
import LogoCliente from "@/components/LogoCliente.vue";
import rulesMixin from "@/mixins/rulesMixin";

export default {
  mixins: [rulesMixin],
  components: { DialogBusca, LogoCliente },
  data: () => ({
    valid: false,
    loading: false,
    dialogBuscaMunicipio: false,
    cliente: {
      razao_social: "",
      nome_fantasia: "",
      cnpj_cpf: "",
      inscricao_estadual: "",
      endereco: "",
      bairro: "",
      complemento: "",
      numero_endereco: "",
      cep: "",
      email: "",
      telefone: "",
      codigo_municipio: null,
      nome_municipio: "",
      codigo_uf: null,
      sigla_uf: "",
      codcliente: null,
    },
  }),
  mounted() {
    this.carregarCliente();
  },
  methods: {
    ...mapActions(["triggerFeedback"]),
    async carregarCliente() {
      this.loading = true;
      try {
        const codcliente = this.$route.params.codcliente;
        const response = await api.get(`/clientes/${codcliente}`);
        this.cliente = response.data;
      } catch (error) {
        alert("Erro ao carregar cliente!");
        console.error(error);
      }
      this.loading = false;
    },
    async salvarCliente() {
      const { valid } = await this.$refs.form.validate();
      if (!valid) return;
      this.loading = true;
      try {
        await api.put(`/clientes/${this.cliente.codcliente}`, this.cliente);
        this.triggerFeedback({
          message: "Cliente alterado com sucesso!",
          color: "success",
          icon: "mdi-check-circle",
        });
        this.$router.push({ name: "clientes" });
      } catch (error) {
        this.triggerFeedback({
          message: "Erro ao salvar cliente!",
          color: "error",
          icon: "mdi-alert-circle",
        });
        console.error(error);
      }
      this.loading = false;
    },
    selecionarMunicipio(municipio) {
      this.cliente.codigo_municipio = municipio.codmunicipioibge;
      this.cliente.nome_municipio = municipio.nome_municipio;
      this.cliente.codigo_uf = municipio.cod_uf;
      this.cliente.sigla_uf = municipio.sigla_uf;
    },
  },
};
</script>

<style scoped>
.v-card-title {
  align-items: center;
  justify-content: center;
}
.v-card-actions {
  justify-content: flex-end;
}
.municipio-caption {
  color: #1976d2;
  font-size: 1.1rem;
  font-weight: 500;
  letter-spacing: 0.2px;
}
</style>
